import FooterBrand from "./footer/FooterBrand";
import FooterQuickLinks from "./footer/FooterQuickLinks";
import FooterTools from "./footer/FooterTools";
import FooterLegal from "./footer/FooterLegal";
import FooterConnect from "./footer/FooterConnect";
import FooterCopyright from "./footer/FooterCopyright";

const ModernFooter = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Brand Section */}
        <FooterBrand />

        {/* Responsive Footer Content - stack on mobile, grid on larger screens */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-8 md:mb-12 text-center sm:text-left items-center">
          <FooterQuickLinks />
          <FooterTools />
          <FooterLegal />
          <FooterConnect />
        </div>

        {/* Bottom Border and Copyright */}
        <FooterCopyright />
      </div>
    </footer>
  );
};

export default ModernFooter;
